/**
 * The XRCamera3D-parent warning of `OpenXRVisibilityMask::get_configuration_warnings()`
 * (openxr_visibility_mask.cpp:67-78). It warns: Godot assigns the mask mesh on
 * `NOTIFICATION_ENTER_TREE` whatever the parent (openxr_visibility_mask.cpp:40-47). A parsed node
 * always enters the tree, so `is_inside_tree()` needs no simulation.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { isExplicitlyHidden, parentTypeVerdict, placementPhrase } from '../../../../linter/parentType.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../linter/ruleArms.js';
const arms = {
    parentNotXRCamera3D: groundedArm('openxrvisibilitymask-parent-not-xrcamera3d', {
        kind: 'configuration-warning',
    }),
};
function checkOpenXRVisibilityMask(context) {
    const { node, scene } = context;
    // `is_visible()` reads only the node's own `visible` flag (node_3d.cpp:1127-1130), so an explicitly
    // hidden mask never reaches Godot's check either.
    if (isExplicitlyHidden(node))
        return [];
    const verdict = parentTypeVerdict(scene, node, 'XRCamera3D');
    // Unlike XRCamera3D, this one DOES warn at the root: its own check casts
    // unconditionally, so a null parent fails it.
    if (verdict.kind === 'satisfied' || verdict.kind === 'unknowable')
        return [];
    const where = placementPhrase(verdict);
    return [
        armDiagnostic(arms.parentNotXRCamera3D, node, `OpenXRVisibilityMask '${node.name}' is ${where}. OpenXR visibility mask must have an XRCamera3D node as their parent, the same configuration warning Godot's own editor reports.`),
    ];
}
const openXRVisibilityMaskParentRule = {
    meta: {
        name: 'valid-openxrvisibilitymask-parent',
        description: "Warns when a visible OpenXRVisibilityMask is not a direct child of an XRCamera3D, Godot's own configuration warning for this node",
        category: 'validation',
        applicableNodeTypes: ['OpenXRVisibilityMask'],
        emits: armEmits(arms),
    },
    check: checkOpenXRVisibilityMask,
};
ruleRegistry.register(openXRVisibilityMaskParentRule);
//# sourceMappingURL=linter.js.map